import { useState } from 'react';
import { AutoTranslate } from '../../hooks/useAutoTranslate';

// Pause-on-hover scrolling marquee for parish announcements.
// Clicks scroll the page to the full announcements section.
const TickerTape = ({ announcements, maxChars = 80 }) => {
  const [isPaused, setIsPaused] = useState(false);

  if (!announcements || announcements.length === 0) return null;

  const truncate = (text) => {
    if (!text) return '';
    return text.length > maxChars ? text.substring(0, maxChars) + '...' : text;
  };

  const scrollToAnnouncements = () => {
    const el = document.getElementById('announcements-section');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div
      className="bg-gradient-to-r from-yellow-600 to-yellow-500 text-white py-2 overflow-hidden"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="overflow-hidden">
        <div
          className={`flex gap-12 px-4 ${isPaused ? '' : 'animate-marquee'}`}
          style={{ animationPlayState: isPaused ? 'paused' : 'running' }}
        >
          {[...announcements, ...announcements].map((a, idx) => (
            <button
              key={`${a.id}-${idx}`}
              onClick={scrollToAnnouncements}
              className="flex-shrink-0 text-sm hover:underline cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <span className="w-1.5 h-1.5 bg-white rounded-full" />
              <AutoTranslate>{truncate(a.title)}</AutoTranslate>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TickerTape;
